/**
 * Renders a text input with a copy button
 * 
 * @prop {string} defaultValue
 * @property {boolean} hideLabel
 * @prop {string} id
 * @prop {string} label
 * @prop {string} [type]
 */
import React from 'react';

// Icons
import * as icons from '../ui/Icons';

const Copy = props => {
  // Get values from props
  const { defaultValue, hideLabel, id, label, type } = props;

  // Create refs
  const input = React.createRef();
  const btn = React.createRef();

  /**
   * Copy the text to the clipboard
   * 
   * @function handleCopy
   */
  const handleCopy = () => {
    if (!input.current) {
      return;
    }

    try {
      input.current.select();
      document.execCommand('copy');
      document.getSelection().removeAllRanges();

      btn.current.classList.add('btn--success');

      setTimeout(() => {
        btn.current.classList.remove('btn--success');
      }, 2000);
    } catch {
      alert('Could not copy to clipboard');
    }
  }

  /**
   * Render the correct field element based on the type property
   * 
   * @function renderField
   */
  const renderField = () => {
    const attributes = {
      defaultValue,
      id,
      ref: input
    }

    if (type === 'textarea') {
      return (
        <textarea {...attributes} />
      )
    } else {
      return (
        <input
          {...attributes}
          type="text"
        />
      )
    }
  }

  return (
    <React.Fragment>
      <label
        className={hideLabel ? 'meta' : 'form__lbl'}
        htmlFor={id}
      >
        {label}
      </label>

      {renderField()}

      <button
        className="btn btn--outline"
        onClick={handleCopy}
        ref={btn}
      >
        <icons.clipboardCopy />
        Copy
      </button>
    </React.Fragment>
  )
}

export default Copy;
